export default __webpack_public_path__ + "static/media/faq.9273e135.svg";